<div id="page-box">
  <overlay-lock>
    <router-outlet></router-outlet>
  </overlay-lock>
  <p-toast id="my-toast" key="toast" position="bottom-right"></p-toast>
</div>
